export const getEmptyResumeData = () => ({
  theme: {
    font: 'Arial',
    fontSize: '14px',
    primaryColor: '#2c3e50',
    accentColor: '#3498db',
    lineHeight: '1.6',
    sectionSpacing: '24px'
  },
  personalInfo: {
    fullName: '',
    email: '',
    phone: '',
    address: '',
    linkedin: '',
    github: '',
    title: ''
  },
  summary: '',
  education: [{
    school: '',
    degree: '',
    startDate: '',
    endDate: '',
    description: ''
  }],
  skills: [],
  professionalExperience: [],
  projects: [],
  certifications: [],
  awards: []
});

export const getSampleResumeData = () => ({
  theme: {
    font: 'Arial',
    fontSize: '14px',
    primaryColor: '#2c3e50',
    accentColor: '#3498db',
    lineHeight: '1.6',
    sectionSpacing: '24px'
  },
  personalInfo: {
    fullName: 'Abhishek Maurya',
    email: 'abhishek.maurya@example.com',
    phone: '+91 9876543210',
    address: 'Varanasi, Uttar Pradesh',
    linkedin: 'linkedin.com/in/abhishek-maurya',
    github: 'https://github.com/abhishek-maurya',
    title: 'IoT Developer & Embedded Systems Engineer'
  },
    summary: 'Dedicated and enthusiastic 3rd-year B.Tech student specializing in Internet of Things (IoT) at XYZ College. Maintaining a strong academic record with 7.5 CGPA. Passionate about emerging technologies and their practical applications in solving real-world problems.',
  education: [{
    school: 'XYZ College of Technology',
    degree: 'B.Tech in Internet of Things (IoT)',
    startDate: '2022',
    endDate: '2026',
    description: 'Current CGPA: 7.5'
  }],
  skills: [
    'IoT Development',
    'Embedded Systems',
    'C++',
    'Python',
    'Arduino',
    'Raspberry Pi',
    'Sensor Integration',
    'Network Protocols',
    'Data Analytics',
    'Problem Solving'
  ],
  professionalExperience: [{
    position: 'IoT Project Intern',
    company: 'Tech Solutions Ltd.',
    location: 'Varanasi',
    startDate: '2023-06',
    endDate: '2023-08',
    description: 'Worked on developing smart home automation solutions using IoT devices and sensors. Implemented real-time monitoring systems and developed user interfaces for device control.'
  }],
  projects: [{
    title: 'Smart Agriculture Monitoring System',
    startDate: '2023-01',
    endDate: '2023-05',
    description: 'Developed an IoT-based system for monitoring soil moisture, temperature, and humidity in agricultural fields. Implemented automated irrigation control based on sensor data.',
    technologies: 'Arduino, Sensors, Python, ThingSpeak'
  },
  {
    title: 'Healthcare Monitoring Device',
    startDate: '2023-09',
    endDate: '2023-12',
    description: 'Created a wearable device for monitoring vital signs using IoT technology. Implemented real-time data transmission and alert system for emergency situations.',
    technologies: 'Raspberry Pi, Health Sensors, MQTT, Node.js'
  }],
  certifications: [{
    name: 'IoT Fundamentals',
    issuer: 'Cisco Networking Academy',
    date: '2023'
  },
  {
    name: 'Python for IoT',
    issuer: 'Coursera',
    date: '2023'
  }],
  awards: [{
    title: 'Best IoT Project',
    issuer: 'XYZ College Technical Fest',
    description: 'Won first prize for Smart Agriculture Monitoring System project'
  }]
});
